module.exports = __webpack_public_path__ + "static/media/Inter-SemiBoldItalic.3d40b592.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Inter/Inter-SemiBoldItalic.woff2
// module id = 706
// module chunks = 21